import clsx from 'clsx';
import moment from 'moment';
import { ReservationSemaphoreRule } from '../models/TransferReservationSemaphore';

interface Props {
  rules: ReservationSemaphoreRule[];
}

const colorClassMap: Record<string, string> = {
  green: 'bg-greenTrafficLight',
  yellow: 'bg-yellowTrafficLight',
  orange: 'bg-orangeTrafficLight',
  red: 'bg-redTrafficLight',
  violet: 'bg-purple-500'
};

const Circle = ({ travelStatus, isContingency }: { travelStatus: string, isContingency: boolean }) => {
  return (
  <div className={clsx("relative z-10 h-8 w-8 rounded-full border-2", isContingency ? 'border-purple-500' : 'border-secondary-400')}>
    <div
      className={clsx("absolute h-6 w-6 rounded-full ", isContingency ? 'bg-purple-700' : 'bg-secondary-600')}
      style={{
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 0
      }}
    />
    <span
      className={clsx("absolute whitespace-nowrap text-sm font-medium ", isContingency ? 'text-purple-500' : 'text-secondary-700')}
      style={{ top: '-25px', left: '50%', transform: 'translateX(-50%)' }}
    >
      {travelStatus}
    </span>
  </div>
);}

const formatDateTime = (dt?: string) => {
  if (!dt) return '-';
  const parsed = moment(dt);
  return parsed.isValid() ? parsed.format('DD/MM HH:mm') : dt;
};

const buildOrderedStates = (rules: ReservationSemaphoreRule[]): string[] => {
  const states: string[] = [];
  rules.forEach((rule, idx) => {
    const parts =
      rule.stage_label?.split(' - ').map((s) => s.trim()).filter(Boolean) ??
      [];
    if (idx === 0) {
      if (parts.length === 0) {
        states.push('');
      } else {
        states.push(...parts);
      }
    } else {
      states.push(parts[parts.length - 1] ?? '');
    }
  });
  return states;
};

export const ViajeTrasladoSemaphoreTimeline = ({ rules }: Props) => {
  

  if (!rules || rules.length === 0) {
    return (
      <p className="text-sm text-inkMuted dark:text-inkMuted-dark">
        No hay información de semáforo disponible.
      </p>
    );
  }

  const orderedStates = buildOrderedStates(rules);

  return (
    <div className="flex w-full px-6 justify-start mx-2 mt-8">
      {orderedStates.map((stateLabel, index) => {
        const isContingency = stateLabel.includes('Contingencia');
        return (
        <div key={index} className="flex flex-col items-center gap-2 w-fit">
          {index > 0 ? (
            <div
              className="animate-in-left flex w-full h-full items-center mb-20"
              style={{ width: '100%' }}
            >
              <div className="relative flex-1 flex flex-col items-center justify-center gap-0 h-full ">
                <div
                  className={clsx("animate-line-grow w-full", isContingency ? 'bg-purple-500' : 'bg-secondary-400')}
                  style={{ minWidth: '190px', height: '2px' }}
                />
                <div className="absolute top-5 flex flex-col gap-2 rounded-lg bg-whiteLight dark:bg-darkLight p-3 border border-secondary-100 dark:border-white/10 z-20 shadow-sm">
                  {(rules[index - 1]?.semaphores ?? []).map((sem, sIdx) => (
                    <div key={sIdx} className="flex items-center gap-2">
                      <div
                        className={clsx(
                          'w-4 h-4 rounded-full border border-secondary-200 dark:border-white/10',
                          colorClassMap[sem.color_key] ?? 'bg-secondary-300 dark:bg-white/20'
                        )}
                      />
                      <span className="text-xs text-inkMuted dark:text-inkMuted-dark whitespace-nowrap">
                        {formatDateTime(sem.to_date)}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
              <Circle travelStatus={stateLabel} isContingency={isContingency} />
            </div>
          ) : (
            <Circle travelStatus={stateLabel} isContingency={isContingency} />
          )}
        </div>
      )})}
    </div>
  );
};

export default ViajeTrasladoSemaphoreTimeline;
